import { ModalityType, type Modality } from '@littlebird/sdk';

const HEREDOC_WRITE_HEADER =
  /^\s*cat\s*>\s*(\S+)\s*<<\s*'?[A-Za-z_]\w*'?[ \t]*\n/;

const ARTIFACT_SOURCE_SUFFIXES = ['.canvas.tsx'];

const isArtifactSourcePath = (filePath: string): boolean =>
  ARTIFACT_SOURCE_SUFFIXES.some((suffix) => filePath.endsWith(suffix));

export const isArtifactWriteModality = (modality: Modality): boolean => {
  if (modality.type !== ModalityType.RunSandbox) return false;
  if (modality.artifact_file_path) return true;

  const header = modality.command?.match(HEREDOC_WRITE_HEADER);
  return header ? isArtifactSourcePath(header[1]) : false;
};
